module.exports = {"elementTypes":{"main":["header","banner","recommended","newsletter","blog","manufacturer","brand","textElement","info-banner","footer"]},"requiredTypes":{"mainBody":[]},"uniqueTypes":[],"globalTypes":["header","footer"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements.json
// module id = 89
// module chunks = 0